import ManageMembership from "./ManageMembership";

const MemberShipsTab = (props) => {
  return <ManageMembership {...props} />;
};

export default MemberShipsTab;
